<template>
  <div class="return-storehouse-apply-container">
    <ds-page-header :title="$t('returnStorehouseApplyManage.page.title')" :subtitle="$t('returnStorehouseApplyManage.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="_goBack">{{ $t('returnStorehouseApplyManage.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="_openReturnStorehouseModel">
          {{ $t('returnStorehouseApplyManage.selectItems') }}
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="_submitApply">
          {{ $t('returnStorehouseApplyManage.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left><span class="ds-panel__title">{{ $t('returnStorehouseApplyManage.title') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="returnStorehouseManageInfo.resourceStores" border
        :empty-description="$t('returnStorehouseApplyManage.page.empty')">
        <el-table-column prop="resId" :label="$t('returnStorehouseApplyManage.itemId')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resId || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('returnStorehouseApplyManage.itemType')" align="center" min-width="140">
          <template slot-scope="scope">{{ scope.row.parentRstName ? scope.row.parentRstName : '-' }} &gt; {{ scope.row.rstName ? scope.row.rstName : '-' }}</template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('returnStorehouseApplyManage.itemName')" align="center" min-width="140" />
        <el-table-column :label="$t('returnStorehouseApplyManage.itemSpec')" align="center" width="110">
          <template slot-scope="scope">{{ scope.row.rssName ? scope.row.rssName : '-' }}</template>
        </el-table-column>
        <el-table-column :label="$t('returnStorehouseApplyManage.stock')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.stock }}{{ scope.row.unitCodeName }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('returnStorehouseApplyManage.miniStock')" align="center" width="130">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.miniStock }}{{ scope.row.miniUnitCodeName }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('returnStorehouseApplyManage.targetWarehouse')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.shzId" style="width:100%">
              <el-option value="" :label="$t('returnStorehouseApplyManage.requiredSelect')" />
              <template v-for="(storehouse, storeIndex) in returnStorehouseManageInfo.storehouses">
                <el-option :key="storeIndex" :value="storehouse.shId" v-if="storehouse.shId != scope.row.shId" :label="storehouse.shName" />
              </template>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnStorehouseApplyManage.returnQuantity')" align="center" min-width="190">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.curStock" :min="0" :max="parseFloat(scope.row.miniStock)" style="width:55%" controls-position="right" />
            {{ scope.row.miniUnitCodeName }}
            <el-button type="info" size="mini" @click="_itemReturnAll(scope.row)">{{ $t('returnStorehouseApplyManage.returnAll') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnStorehouseApplyManage.operation')" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="_openDeleteResourceStoreModel(scope.row)">{{ $t('returnStorehouseApplyManage.cancelReturn') }}</el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header"><span class="ds-panel__title">{{ $t('returnStorehouseApplyManage.returnDescription') }}</span></div>
      <el-form label-width="120px" class="ds-form">
        <el-form-item :label="$t('returnStorehouseApplyManage.returnDescription')">
          <el-input type="textarea" v-model="returnStorehouseManageInfo.remark" :placeholder="$t('returnStorehouseApplyManage.requiredDescription')" :rows="2" />
        </el-form-item>
      </el-form>
    </div>

    <choose-resource-staff ref="chooseResourceStaff" @setSelectResourceStores="handleSetSelectResourceStores" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import ChooseResourceStaff from '@/components/resource/chooseResourceStaff.vue'
import { listStorehouses, saveAllocationStorehouse } from '@/api/resource/returnStorehouseApplyManageApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'ReturnStorehouseApplyManageList',
  components: { ChooseResourceStaff, DsPageHeader, DsToolbar, DsDataTable },
  data() {
    return {
      returnStorehouseManageInfo: { resourceStores: [], storehouses: [], remark: '', communityId: '', apply_type: 20000 }
    }
  },
  created() {
    this.returnStorehouseManageInfo.communityId = getCommunityId()
    this._listReturnStorehouse()
  },
  methods: {
    _openDeleteResourceStoreModel(resourceStore) {
      this.returnStorehouseManageInfo.resourceStores = this.returnStorehouseManageInfo.resourceStores.filter(item => item.resId !== resourceStore.resId)
      this.$refs.chooseResourceStaff.removeSelectItem(resourceStore.resId)
    },
    _itemReturnAll(resourceStore) {
      const item = this.returnStorehouseManageInfo.resourceStores.find(item => item.resId === resourceStore.resId)
      if (item) { item.curStock = item.miniStock }
    },
    _openReturnStorehouseModel() { this.$refs.chooseResourceStaff.open() },
    async _listReturnStorehouse() {
      try {
        const params = { page: 1, row: 100, isShow: true, shType: '2807', communityId: this.returnStorehouseManageInfo.communityId }
        const { data } = await listStorehouses(params)
        this.returnStorehouseManageInfo.storehouses = data
      } catch (error) { console.error('请求失败:', error) }
    },
    _goBack() { this.$router.go(-1) },
    async _submitApply() {
      if (!this.returnStorehouseManageInfo.remark) { this.$message.error(this.$t('returnStorehouseApplyManage.descriptionRequired')); return }
      if (this.returnStorehouseManageInfo.resourceStores.length === 0) { this.$message.error(this.$t('returnStorehouseApplyManage.selectItemsRequired')); return }
      let isValid = true
      this.returnStorehouseManageInfo.resourceStores.forEach(item => {
        item.curStock = parseFloat(item.curStock)
        if (item.curStock <= 0) { this.$message.error(this.$t('returnStorehouseApplyManage.quantityRequired')); isValid = false; return }
        if (item.curStock > parseFloat(item.miniStock)) { this.$message.error(`${item.resName}${this.$t('returnStorehouseApplyManage.stockNotEnough')}`); isValid = false; return }
        if (!item.shzId) { this.$message.error(this.$t('returnStorehouseApplyManage.targetWarehouseRequired')); isValid = false; return }
      })
      if (!isValid) return
      try {
        const res = await saveAllocationStorehouse(this.returnStorehouseManageInfo)
        if (res.code === 0) { this.$message.success(this.$t('common.operationSuccess')); this._goBack() }
        else { this.$message.error(res.msg) }
      } catch (error) { console.error('提交失败:', error); this.$message.error(this.$t('returnStorehouseApplyManage.returnFailed')) }
    },
    handleSetSelectResourceStores(resourceStores) {
      const oldList = this.returnStorehouseManageInfo.resourceStores
      const newList = resourceStores.filter(newItem => !oldList.some(oldItem => oldItem.resId === newItem.resId))
      newList.forEach(item => { item.shaName = item.shName; item.shzId = ''; item.curStock = '0' })
      this.returnStorehouseManageInfo.resourceStores = [...newList, ...oldList]
    }
  }
}
</script>

<style lang="scss" scoped>
.return-storehouse-apply-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header { display: flex; align-items: center; justify-content: space-between; padding-bottom: var(--ds-spacing-md); margin-bottom: var(--ds-spacing-md); border-bottom: 1px solid var(--ds-gray-200); }
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
.ds-form { margin-top: var(--ds-spacing-sm); }
</style>
